import clsx from 'clsx';
import { FC, ReactNode } from 'react';

interface ServiceOptionCardProps {
  icon: ReactNode;
  title: string;
  description: string;
  selected: boolean;
  onToggle: () => void;
}

export const ServiceOptionCard: FC<ServiceOptionCardProps> = ({
  icon,
  title,
  description,
  selected,
  onToggle,
}) => (
  <button
    type="button"
    onClick={onToggle}
    aria-pressed={selected}
    className={clsx(
      'flex flex-1 items-start gap-3 rounded-lg border p-4 text-left transition-colors',
      selected
        ? 'border-day-neutral-dark bg-day-light-3'
        : 'border-day-light-2 bg-day-light-5 hover:border-day-neutral-dark',
    )}
  >
    <span
      className={clsx(
        'flex h-9 w-9 shrink-0 items-center justify-center rounded-md',
        selected
          ? 'bg-day-neutral-dark text-day-light-5'
          : 'bg-day-light-2 text-day-neutral-subtle',
      )}
    >
      {icon}
    </span>
    <span className="flex flex-col">
      <span className="font-semibold text-day-neutral-dark">{title}</span>
      <span className="mt-0.5 text-sm text-day-neutral-subtle">{description}</span>
    </span>
  </button>
);
